import { render, staticRenderFns } from "./meine-visitenkarte.vue?vue&type=template&id=6629b22f&lang=pug&"
import script from "./meine-visitenkarte.vue?vue&type=script&lang=js&"
export * from "./meine-visitenkarte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports